export default "__VITE_ASSET__Cp3PO60W__"